import React, { Component } from 'react';
import data from "../resumeData.json";

class Footer extends Component {
  render() {
    if(data){
      var networks= data.main.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
    <>
     <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>
        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
  </>
    );
  }
}

export default Footer;
